import { RoutePageType } from "@routes/interfaces"
import Login from "./pages/Login"
import Logout from "./pages/Logout"

const authPages: RoutePageType[] = [
    {key: 'login', element: Login},
    {key: 'logout', element: Logout},
]

export default authPages